module.exports = __webpack_public_path__ + "img/3.66f6f628.jpg";